import React from 'react';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-layout">
      <div className="auth-container">
        <div className="auth-brand">
          <img src="/logo.png" alt="Workstack" className="auth-logo-img" />
          <p className="auth-tagline">Your team's project command centre</p>
        </div>
        <div className="auth-card">
          {children}
        </div>
      </div>
      <div className="auth-footer">
        <p>&copy; {new Date().getFullYear()} Fugetron. All rights reserved.</p>
      </div>
    </div>
  );
};

export default AuthLayout;
